import React, { useEffect, useState } from "react";
import { FaRegUserCircle } from "react-icons/fa";
import { FiXCircle } from "react-icons/fi";
import styled from "styled-components";
import coin1 from "../assets/icons/moeda-1.svg";
import coin10 from "../assets/icons/moeda-10.svg";
import coin100 from "../assets/icons/moeda-100.svg";
import coin5 from "../assets/icons/moeda-5.svg";
import coin50 from "../assets/icons/moeda-50.svg";
import { getUserData, getUserHistory } from "../controllers/userController";
import {
  BackgroundColor,
  Blue,
  Border,
  ErrorComponent,
  Green,
  PrimaryColor,
  TextColorDark,
  TextColorLight,
  Yellow,
} from "../styles/global";
import { Container, Content, ContentSection } from "../styles/styles";
import { toast } from "react-toastify";

const DateInput = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  background-color: ${TextColorLight};
  padding: 20px;
  border-radius: 8px;
  font-size: 14px;
  justify-content: space-between;

  input {
    display: block;
    width: 100%;
    border: none;
    background: transparent;
    font-size: 14px;
  }

  svg {
    width: 30px;
    color: ${PrimaryColor};
  }

  div {
    display: flex;
    justify-content: start;
    align-items: center;
    width: fit-content;
    gap: 20px;
  }
`;

const Header = styled.header`
  background: linear-gradient(185deg, ${Blue} 28%, ${Yellow} 0%);
  color: white;
  padding: 14px;
  padding-bottom: 28px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 18px;

  .headerText {
    margin-top: 18px;
    text-align: center;
    font-size: 18px;
    font-weight: normal;
  }
`;

const BackButton = styled.a`
  margin-top: 22px;
  display: flex;
  align-items: center;
  color: #fff;
  text-decoration: none;
  font-size: 20px;
  width: fit-content;
`;

const JustificationForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 600px;
  padding-block: 20px;
  border-radius: 10px;

  .moeda {
    width: 50px !important;
  }
`;

const Employee = styled(Container)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 30px;

  .employee-name {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    gap: 10px;
    text-align: left;

    h4 {
      color: #000;
      font-size: 14px;
      font-weight: 300;
    }
  }

  .employee-details {
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 0px;
    flex: 1;

    p,
    small {
      text-align: end;
      color: #000;
      font-size: 14px;
      width: max-content;
    }

    p {
      font-weight: 500;
    }
    small {
      font-weight: lighter;
    }
  }

  .employee-icon-div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: ${Border};
    text-align: center;
    padding: 10px;
  }
  .employee-icon {
    font-size: 25px;
    color: #444;
  }
`;

const Label = styled.div`
  color: ${PrimaryColor};
  font-size: 18px;
  font-weight: 400;
  text-align: start;
`;

const SelectReason = styled(Container)`
  flex-direction: column;
  text-align: left;
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid ${Border};

  p {
    color: ${TextColorDark};
    padding: 0 5px;
    font-size: 12px;
  }

  select {
    background-color: transparent;
    border: none;
    color: #000;
    font-family: "Roboto", sans-serif;
    &:focus-visible {
      outline: 0px;
    }
  }
`;

const SubmitButton = styled.button`
  background-color: ${Green};
  padding: 10px 70px;
  border-radius: 30px;
  border: none;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  cursor: pointer;
  align-self: center;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
  color: ${PrimaryColor};
  font-size: 14px;
`;

const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
  color: #666;
  font-size: 14px;
`;

const JustificarEmocao = ({
  emocionador,
  moedas,
  onSubmit,
  onBack,
  onClose,
  errorMessage,
}) => {
  const currentDate = new Date().toISOString().split("T")[0];

  const [justification, setJustification] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [displayDate, setDisplayDate] = useState("");
  const [isoDate, setIsoDate] = useState(currentDate);
  const [file, setFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [userData, setUserData] = useState({});
  const [history, setHistory] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const userInfo = await getUserData(user.idusuario);
        setUserData(userInfo);

        const userHistory = await getUserHistory(user.idusuario);
        setHistory(userHistory);
      } catch (error) {
        setError("Erro ao carregar dados.");
        toast.error("Erro ao carregar dados do usuário.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user.idusuario]);

  useEffect(() => {
    const currentDate = new Date();
    setDisplayDate(
      currentDate.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
    );
    setIsoDate(currentDate.toISOString());
  }, []);

  const handleChange = (e) => setJustification(e.target.value);

  const handleReasonChange = (e) => setSelectedReason(e.target.value);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
    setPreviewImage(URL.createObjectURL(file)); // Mostra a imagem selecionada
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      justification,
      reason: selectedReason,
      date: selectedDate,
      file,
    });
  };

  const permissaoHoraDaEmocao = (cargo) =>{
    const cargosPermitidos = [
      "Gerente Geral",
      "Gestor",
      "TCF Corporativo",
      "Gerente TCF",
      "Coordenador",
      "Supervisor"
    ]
      return cargosPermitidos.includes(cargo);
  };


  const today = new Date().toISOString().split('T')[0];
  
  const reasonTexts = {
    Rir: "Quem ri mais vive mais. Torne nosso atendimento caloroso.",
    "Cumprimente sempre":
      "Cumprimente o hóspede com um sorriso, um gesto Tauá e palavras calorosas.",
    "Converse com o hóspede":
      "Aproxime-se e pergunte se ele precisa de algo para se sentir em casa.",
    "O cliente é o rei":
      "Pare tudo o que está fazendo. Dê atenção ao hóspede: resolva o problema, carregue a mala, acompanhe-o até onde ele quer ir, pegue o que ele precisa.",
    "Seja colaborativo":
      "Ajude os colegas e outros setores. Pegue o papel do chão: todos somos responsáveis pela limpeza.",
    "Atenção total, cara alegre e rápido":
      "Trabalhe com excelência e atenção aos detalhes. Mantenha o foco e evite o uso do celular durante o trabalho.",
    "Tauá é uma empresa de oportunidades":
      "Capacite-se e se esforce. Queremos e incentivamos o crescimento interno.",
    "Cante a música 'Amigos para sempre'":
      "Cante alto, com entusiasmo e com um sorriso no rosto.",
    "Trabalhe em prol do resultado":
      "Acompanhe suas metas e seja ético em suas atitudes e tarefas.",
    "Seja feliz":
      "Fazer alguém feliz também nos faz felizes. Tenha humildade, simplicidade, respeito e gratidão.",
    "Hora da Emoção": "Hora da Emoção",
    "Programa Anjo": "Atribuição especial do TCF",
    "Premiação Guardiões Mais Tauá": "Atribuição especial do TCF",
    "Premiação Sala de Vendas Mais Tauá": "Atribuição especial do TCF",
    "Emocionador 6 estrelas": "Atribuição especial do TCF",
    "Liderança 6 estrelas": "Atribuição especial do TCF",
    "Conclusão de curso da Unisorriso": "Atribuição especial do TCF",
    "Premiação Mais Citados Pelos Clientes": "Atribuição especial do TCF",
    "Saldo inicial de moedas": "Atribuição especial do TCF",
    "Premiação da Diretoria": "Atribuição especial do TCF",
    Premiação: "Atribuição especial do TCF",
  };

  // Loading state
  if (loading) {
    return (
      <>
        <Header>
          <h1 className="headerText">Emocionar</h1>
          <BackButton onClick={onClose}>
            <FiXCircle />
          </BackButton>
        </Header>
        <Container direction="column" width="100%">
          <ContentSection fullWidth padding="10px">
            <LoadingContainer>
              <p>Carregando dados do usuário...</p>
            </LoadingContainer>
          </ContentSection>
        </Container>
      </>
    );
  }

  // Error state
  if (error && !userData) {
    return (
      <>
        <Header>
          <h1 className="headerText">Emocionar</h1>
          <BackButton onClick={onClose}>
            <FiXCircle />
          </BackButton>
        </Header>
        <Container direction="column" width="100%">
          <ContentSection fullWidth padding="10px">
            <EmptyContainer>
              <p>Não foi possível carregar os dados.</p>
              <p>Tente novamente mais tarde.</p>
            </EmptyContainer>
          </ContentSection>
        </Container>
      </>
    );
  }

  return (
    <>
      <Header>
        <h1 className="headerText">Emocionar</h1>
        <BackButton onClick={onClose}>
          <FiXCircle />
        </BackButton>
      </Header>
      <Container direction="column" width="100%" padding="10px">
        <ContentSection fullWidth padding="10px">
          <Content padding="0px">
            <JustificationForm onSubmit={handleSubmit}>
              <Label>Emocionador</Label>
              <Employee fullWidth padding="0px">
                <div className="employee-name">
                  <div className="employee-icon-div">   
                    <FaRegUserCircle className="employee-icon" />
                  </div>
                  <h4>{emocionador.nome}</h4>
                </div>
                <div className="employee-details">
                  <p>{emocionador.unidade}</p>
                  <small>{emocionador.setor}</small>
                </div>
              </Employee>

              <Label>Moedas</Label>
              <Container padding="0px">
                {moedas["1"] > 0 && (
                  <img src={coin1} alt="1 Moeda" className="moeda" />
                )}
                {moedas["5"] > 0 && (
                  <img src={coin5} alt="5 Moedas" className="moeda" />
                )}
                {moedas["10"] > 0 && (
                  <img src={coin10} alt="10 Moedas" className="moeda" />
                )}
                {moedas["50"] > 0 && (
                  <img src={coin50} alt="50 Moedas" className="moeda" />
                )}
                {moedas["100"] > 0 && (
                  <img src={coin100} alt="100 Moedas" className="moeda" />
                )}
              </Container>

              <Container direction="column" gap="20px" padding="0px">
                <Label>Mandamento</Label>
                <SelectReason>
                  <select
                    value={selectedReason}
                    onChange={handleReasonChange}
                    required
                  >
                    <option value="">Selecione uma razão</option>
                    <option value="Rir">Rir</option>
                    <option value="Cumprimente sempre">
                      Cumprimente sempre
                    </option>
                    <option value="Converse com o hóspede">
                      Converse com o hóspede
                    </option>
                    <option value="O cliente é o rei">O cliente é o rei</option>
                    <option value="Seja colaborativo">Seja colaborativo</option>
                    <option value="Atenção total, cara alegre e rápido">
                      Atenção total, cara alegre e rápido
                    </option>
                    <option value="Tauá é uma empresa de oportunidades">
                      Tauá é uma empresa de oportunidades
                    </option>
                    <option value="Cante a música 'Amigos para sempre'">
                      Cante a música 'Amigos para sempre'
                    </option>
                    <option value="Trabalhe em prol do resultado">
                      Trabalhe em prol do resultado
                    </option>
                    <option value="Seja feliz">Seja feliz</option>
                    {/** Admin only options*/}
                    {user.nivel == 1 ? (
                      <>
                        <option value="Hora da Emoção">Hora da Emoção</option>
                        <option value="Programa Anjo">Programa Anjo</option>
                        <option value="Premiação Guardiões Mais Tauá">
                          Premiação Guardiões Mais Tauá
                        </option>
                        <option value="Premiação Sala de Vendas Mais Tauá">
                          Premiação Sala de Vendas Mais Tauá
                        </option>
                        <option value="Emocionador 6 estrelas">
                          Emocionador 6 estrelas
                        </option>
                        <option value="Liderança 6 estrelas">
                          Liderança 6 estrelas
                        </option>
                        <option value="Conclusão de curso da Unisorriso">
                          Conclusão de curso da Unisorriso
                        </option>
                        <option value="Premiação Mais Citados Pelos Clientes">
                          Premiação Mais Citados Pelos Clientes
                        </option>
                        <option value="Saldo inicial de moedas">
                          Saldo inicial de moedas
                        </option>
                        <option value="Premiação da Diretoria">
                          Premiação da Diretoria
                        </option>
                        <option value="Premiação">Premiação </option>
                      </>
                    ) : null}
                    {/* Opções apenas para cargos permitidos */}
                      {permissaoHoraDaEmocao(user.cargo) && (
                        <option value="Hora da Emoção">Hora da Emoção</option>
                      )}
                  </select>

                  {selectedReason && <p>{reasonTexts[selectedReason]}</p>}
                </SelectReason>
                

                <Container direction="column" gap="10px" padding="0px">
                  <Label>Quando emocionou?</Label>
                  <DateInput>
                    <label htmlFor="date-picker">Selecione a data:</label>
                    <input
                      id="date-picker"
                      type="date"
                      value={selectedDate}
                      onChange={handleDateChange}
                      max={today}
                      required
                    />
                  </DateInput>
                </Container>
              </Container>

              {errorMessage && (
                <ErrorComponent message={errorMessage} duration={8000} />
              )}

              <SubmitButton type="submit">Confirmar</SubmitButton>
            </JustificationForm>
          </Content>
        </ContentSection>
      </Container>
    </>
  );
};

export default JustificarEmocao;